<template>
  <div id="wrapper" class="page" v-if="project_contract_read">
    <!-- <contract-side-bar index="1" /> -->
    <div id="content-wrapper">
      <div class="container-fluid">
        <div class="form-inline">
          <button class="btn btn-info mb-2 mr-2" @click.prevent="addItem">
            <i class="fas fa-plus"></i>
            Add
            <!-- Thêm -->
          </button>
          <!-- <div style="flex-grow: 1" /> -->
          <!-- Sao chua co ta -->
          <!-- <button class="btn btn-success mb-2" @click.prevent="openReportModal">
            <i class="far fa-file-alt"></i> Report
          </button> -->
        </div>
        <b-row>
          <b-col cols="12">
            <div class="form-inline">
              <b-form-select
                v-model="year_selected"
                class="mb-2 mr-2"
                style="width: 7%"
                :options="optionsYear"
                value-field="value"
                text-field="text"
                @change="queryItem"
              >
                <template #first>
                  <b-form-select-option value="0">
                    All
                    <!-- Tất cả -->
                  </b-form-select-option>
                </template>
              </b-form-select>
              <!-- filter month when have a year -->
              <!-- <b-form-select v-if="year_selected!=0" v-model="month_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsMonth" value-field="value" text-field="text" @change="queryItem"> -->
              <b-form-select
                v-model="month_selected"
                class="mb-2 mr-2"
                style="width: 7%"
                :options="optionsMonth"
                value-field="value"
                text-field="text"
                @change="queryItem"
              >
                <template #first>
                  <b-form-select-option value="0">
                    All
                    <!-- Tất cả -->
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-form-input
                class="mb-2"
                style="flex-grow: 1"
                v-model="query"
                placeholder="Search by project, customer"
                @keydown.enter.prevent="queryItem"
              ></b-form-input>
              <button class="btn" @click.prevent="queryItem">
                <i class="fas fa-search"></i>
              </button>
              <button class="btn" id="popover-target-1">
                <i class="fas fa-filter"></i>
              </button>
            </div>

            <b-popover target="popover-target-1" triggers="click blur">
              <template v-slot:title>
                Filter by status
                <!-- Lọc tình trạng -->
              </template>
              <!-- <b-form-select
                v-model="tinhtrang"
                :options="tinhtranghopdongs"
                text-field = "pickListValue"
                value-field = "id"
                @change="queryItem"
              > -->
              <select
                style="font-size: 15px; font-family: arial"
                :style="{
                  background:
                    this.tinhtrang == '-1'
                      ? '#FFEEFD'
                      : this.tinhtrang == '1'
                      ? '#FFE1C6'
                      : this.tinhtrang == '2'
                      ? '#FFFFD7'
                      : this.tinhtrang == '3'
                      ? '#C0F7FE'
                      : '#FFEEFD',
                }"
                name="select"
                @change="queryItem"
                v-model="tinhtrang"
                id="rgb"
              >
                <option
                  id="violet"
                  value="-1"
                  style="font-size: 15px;font-family: arial; background-color: #FFEEFD"
                  >
                  All
                  <!-- Tất cả -->
                  </option
                >
                <option
                  id="orange"
                  value="1"
                  style="font-size: 15px;font-family: arial; background-color: #FFE1C6"
                  >
                    Not acceptance
                  <!-- Chưa nghiệm thu -->
                  </option
                >
                <option
                  id="yellow"
                  value="2"
                  style="font-size: 15px;font-family: arial; background-color: #FFFFD7"
                  >
                    Unpaid
                  <!-- Chưa thanh toán đủ -->
                  </option
                >
                <option
                  id="blue"
                  value="3"
                  style="font-size: 15px;font-family: arial; background-color: #C0F7FE"
                  >
                    Done
                    <!-- Hoàn thành -->
                  </option
                >
              </select>
              <!-- <b-form-select
                v-model="tinhtrang"
                :options="optionsTinhTrang"
                text-field = "text"
                value-field = "value"
                @change="queryItem"
              >
                <template v-slot:first>
                  <b-form-select-option value="-1"
                    >Tất cả</b-form-select-option
                  >
                </template>
              </b-form-select> -->
            </b-popover>
            <b-table
              bordered
              head-variant="dark"
              hover
              responsive
              striped
              small
              table-variant="light"
              :fields="fields"
              :items="items"
            >
              <template #cell(STT)="data">{{ data.index + 1 }}</template>
              <!-- <template v-slot:cell(ngayky)="data">{{data.item.ngayky | moment('DD/MM/YYYY')}}</template> -->
              <template v-slot:cell(ngaybatdau)="data">
                <span v-if="data.item.ngaybatdau">
                  {{ data.item.ngaybatdau | moment("DD/MM/YYYY") }}
                </span>
              </template>
              <!-- v-b-tooltip.hover.auto.html="{variant: 'info', title:'<pre>' + data.item.hopdong_note + '</pre>'}"> -->
              <template v-slot:cell(tieude)="data">
                <div v-if="data.item.hopdong_note != null">
                  <span v-if="data.item.hopdong_note.length != 0">
                    <strong>{{ data.item.tieude }}</strong>
                    <sup>
                      <i
                        v-b-tooltip.hover.bottomright.html="{
                          title:
                            '<strong>' + data.item.hopdong_note + '</strong>',
                        }"
                        class="fas fa-info-circle fa"
                      ></i
                    ></sup>
                  </span>
                  <span v-else
                    ><strong>{{ data.item.tieude }}</strong></span
                  >
                </div>

                <div v-else>
                  <strong>{{ data.item.tieude }}</strong>
                </div>
              </template>

              <!-- <template v-slot:cell(giatrihopdong)="data">{{data.item.giatrihopdong | numeral('0,0')}}</template> -->
              <template v-slot:cell(giatriduocnghiemthu)="data">
                <span v-if="data.value != 0">
                  {{ data.item.giatriduocnghiemthu | numeral("0,0") }}
                </span>
              </template>
              <template v-slot:cell(dathu)="data">
                <span v-if="data.value != 0">
                  {{ data.item.dathu | numeral("0,0") }}
                </span>
              </template>
              <template v-slot:cell(still_left)="data">
                <span
                  v-if="data.item.giatriduocnghiemthu - data.item.dathu != 0"
                >
                  <strong>{{
                    (data.item.giatriduocnghiemthu - data.item.dathu)
                      | numeral("0,0")
                  }}</strong>
                </span>
              </template>
              <template v-slot:cell(departmentid)="data">{{
                data.item.departmentid == null
                  ? ""
                  : findFirstDepartment(departments, data.item.departmentid)
              }}</template>
              <template v-slot:cell(tinhtrang)="data">
                <b-badge variant="default" v-if="data.item.tinhtrang == null">
                </b-badge>
                <b-badge variant="danger" v-else-if="data.item.tinhtrang == 50">
                  {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
                </b-badge>
                <b-badge
                  variant="danger2"
                  v-else-if="data.item.tinhtrang == 51"
                >
                  {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
                </b-badge>
                <b-badge
                  variant="warning"
                  v-else-if="data.item.tinhtrang == 52"
                >
                  {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
                </b-badge>
                <b-badge variant="info" v-else-if="data.item.tinhtrang == 53">
                  {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
                </b-badge>
                <b-badge
                  variant="primary"
                  v-else-if="
                    data.item.tinhtrang > 53 && data.item.tinhtrang <= 146
                  "
                >
                  {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
                </b-badge>
                <b-badge
                  variant="success"
                  v-else-if="data.item.tinhtrang > 146"
                >
                  {{ findPickList(tinhtranghopdongs, data.item.tinhtrang) }}
                </b-badge>
              </template>
              <!-- {{data.item.tinhtrang == null ? "" : findPickList(tinhtranghopdongs, data.item.tinhtrang)}}</template> -->
              <!-- Neu co ngay ban giao thuc te thi lay ngay ban giao thuc te, nguoc lai lay ngay ban giao du kien -->
              <!-- {{(data.item.ngaybangiaothucte == null ? data.item.ngaybangiao : data.item.ngaybangiaothucte)| moment('DD/MM/YYYY')}} -->
              <template v-slot:cell(ngaybangiao)="data">
                <div v-if="data.item.ngaybangiaothucte">
                  {{ data.item.ngaybangiaothucte | moment("DD/MM/YYYY") }}
                </div>
                <div v-else-if="data.item.ngaybangiao != null">
                  <span v-if="new Date(data.item.ngaybangiao) <= Date.now()">
                    <b-badge variant="danger3">
                      {{ data.item.ngaybangiao | moment("DD/MM/YYYY") }}
                    </b-badge>
                  </span>

                  <span v-else>
                    <b-badge variant="info3">
                      {{ data.item.ngaybangiao | moment("DD/MM/YYYY") }}
                    </b-badge>
                  </span>
                  <!-- <span
                  style="background-color:#FAD5DA;"
                  v-if="new Date(data.item.ngaybangiao) <= Date.now()">
                    <strong>
                      {{data.item.ngaybangiao | moment('DD/MM/YYYY')}}
                    </strong>
                  </span> -->
                  <!-- <span v-else
                  style="background-color:#C9DECE;">
                    <strong>
                      {{data.item.ngaybangiao | moment('DD/MM/YYYY')}}
                    </strong>
                  </span> -->
                </div>
              </template>

              <template v-slot:cell(ngayxacnhannghiemthu)="data">
                <div v-if="data.item.ngaynghiemthu">
                  {{ data.item.ngaynghiemthu | moment("DD/MM/YYYY") }}
                </div>
                <!-- <div v-else-if="data.item.ngayxacnhannghiemthu">
                  <span
                  style="background-color:#FAD5DA;"
                  v-if="new Date (data.item.ngayxacnhannghiemthu) <= Date.now()">
                    <strong>
                      {{data.item.ngayxacnhannghiemthu | moment('DD/MM/YYYY')}}
                    </strong>
                  </span>
                  <span v-else
                  style="background-color:#C9DECE;">
                    <strong>
                      {{data.item.ngayxacnhannghiemthu | moment('DD/MM/YYYY')}}
                    </strong>
                  </span>
                </div> -->
                <div v-else-if="data.item.ngayxacnhannghiemthu">
                  <span
                    v-if="
                      new Date(data.item.ngayxacnhannghiemthu) <= Date.now()
                    "
                  >
                    <b-badge variant="danger3">
                      {{
                        data.item.ngayxacnhannghiemthu | moment("DD/MM/YYYY")
                      }}
                    </b-badge>
                  </span>

                  <span v-else>
                    <b-badge variant="info3">
                      {{
                        data.item.ngayxacnhannghiemthu | moment("DD/MM/YYYY")
                      }}
                    </b-badge>
                  </span>
                </div>
              </template>

              <!-- <template v-slot:cell(ngayxacnhannghiemthu)="data">{{(data.item.ngaynghiemthu == null ? data.item.ngayxacnhannghiemthu : data.item.ngaynghiemthu)| moment('DD/MM/YYYY')}}</template> -->
              -->
              <!-- <template v-slot:cell(ngayxacnhannghiemthu)="data">{{data.item.ngayxacnhannghiemthu | moment('DD/MM/YYYY')}}</template> -->
              <template v-slot:cell(action)="data">
                <b-link
                  class="text-primary mr-2"
                  href="#"
                  @click="updateItem(data)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </b-link>
                <b-link
                  class="text-danger"
                  href="#"
                  @click.prevent="deleteItem(data)"
                >
                  <i class="fas fa-trash"></i>
                </b-link>
                <!-- <button class="btn btn-info mr-1" @click="updateItem(data)">
                  <i class="fas fa-pencil-alt"></i>
                </button>
                <button class="btn btn-danger" @click="deleteItem(data)">
                  <i class="fas fa-trash-alt"></i>
                </button> -->
              </template>
              <template v-slot:cell(ngaythanhtoandukien)="data">
                <div v-if="findNextPaymentDate(paymentdates, data.item.id)">
                  <!-- <span
                  style="background-color:#FAD5DA;"
                  v-if="new Date (findNextPaymentDate(paymentdates, data.item.id)) <= Date.now()">
                    <strong>
                      {{findNextPaymentDate(paymentdates, data.item.id) | moment('DD/MM/YYYY')}}
                    </strong>
                  </span>
                  <span v-else
                  style="background-color:#C9DECE;">
                    <strong>
                        {{findNextPaymentDate(paymentdates, data.item.id) | moment('DD/MM/YYYY')}}
                    </strong>
                  </span> -->
                  <span
                    v-if="
                      new Date(
                        findNextPaymentDate(paymentdates, data.item.id)
                      ) <= Date.now()
                    "
                  >
                    <b-badge variant="danger3">
                      {{
                        findNextPaymentDate(paymentdates, data.item.id)
                          | moment("DD/MM/YYYY")
                      }}
                    </b-badge>
                  </span>
                  <span v-else>
                    <b-badge variant="info3">
                      {{
                        findNextPaymentDate(paymentdates, data.item.id)
                          | moment("DD/MM/YYYY")
                      }}
                    </b-badge>
                  </span>
                </div>
              </template>

              <template slot="bottom-row">
                <td style="text-align:center" colspan="6"><b>
                  SUM
                  <!-- TỔNG -->
                </b></td>
                <td style="text-align:right">
                  <b>{{ sum_giatriduocnghiemthu | numeral("0,0") }}</b>
                </td>
                <td style="text-align:right">
                  <b>{{ sum_dathanhtoan | numeral("0,0") }}</b>
                </td>
                <td style="text-align:right">
                  <b>{{ sum_conphaithanhtoan | numeral("0,0") }}</b>
                </td>
                <td></td>
                <td></td>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>

      <!-- REPORT MODAL -->
      <!-- <b-modal
        v-model="reportModalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        title="BÁO CÁO HỢP ĐỒNG"
        text-center
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b> Hợp đồng </b>
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="contract"
                :options="contracts"
                value-field="id"
                text-field="ten"
              >
                <template #first>
                  <b-form-select-option :value="null"
                    >Tất cả
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="mr-2"
                variant="info"
                @click.prevent="selectContract"
              >
                <i class="fas fa-check mr-2"></i>Chọn
              </b-button>
              <b-button
                class="mr-2"
                variant="secondary"
                @click.prevent="closeReportModal"
              >
                <i class="fas fa-times mr-2"></i>Đóng
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal> -->
      <!-- END OF REPORT MODAL -->

      <!-- CONTRACT MODAL -->
      <!-- <b-modal
        size="xl"
        v-model="contractModalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        title="THÔNG TIN HỢP ĐỒNG"
        text-center
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <danh-sach-hop-dong></danh-sach-hop-dong>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="mr-2"
                variant="success"
                @click.prevent="excelReport"
                style="float:right;"
              >
                <i class="far fa-file-excel mr-2"></i>Xuất Excel
              </b-button>
              <b-button
                class="mr-2"
                variant="secondary"
                @click.prevent="closeContractModal"
                style="float:right;"
              >
                <i class="fas fa-times mr-2"></i>Đóng
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal> -->
      <!-- END OF CONTRACT MODAL -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import DanhSachHopDong from "../components/Project/Report/Report2";

//import ContractSideBar from "../components/Contract/ContractSideBar";
//import AddContractModal from "../components/Contract/AddContractModal";

export default {
  name: "Contracts",
  components: {
    // DanhSachHopDong,
    //ContractSideBar,
  },
  data() {
    return {
      fields: [
        {
          key: "STT",
          // label: "STT",
          label: "No.",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "tieude",
          label: "Project",
          // label: "Dự án",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ngaybatdau",
          label: "Shooting date",
          // label: "Ngày quay",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "tinhtrang",
          label: "Status",
          // label: "Trạng thái",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // {
        //   key: "departmentid",
        //   label: "Phòng ban",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: {width: "70px", textAlign : "center"},
        // },
        {
          key: "ngaybangiao",
          label: "Actual Delivery Date",
          // label: "Ngày bàn giao SP",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "ngayxacnhannghiemthu",
          label: "Acceptance date",
          // label: "Ngày nghiệm thu",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        // {
        //   key: "giatrihopdong",
        //   label: "Giá trị hợp đồng",
        //   tdClass: 'text-right',
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {width: "120px", textAlign : "center"},
        // },
        {
          key: "giatriduocnghiemthu",
          label: "Acceptance value",
          // label: "Giá trị nghiệm thu",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "dathu",
          label: "Paid",
          // label: "Đã thanh toán",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "still_left",
          label: "Remaining amount",
          // label: "Còn phải thanh toán",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        // {
        //   key: "ngayky",
        //   label: "Ngày ký",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "ten",
        //   label: "Khách hàng",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {width: "200px ", textAlign : "center"},
        // },
        {
          key: "ngaythanhtoandukien",
          label: "Payment due date",
          // label: "Thời hạn thanh toán",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: { width: "50px !important",minWidth: "50px !important", textAlign: "center" },
        },
      ],
      items: [],
      departments: [],
      tinhtranghopdongs: [],
      paymentdates: [],
      query: null, //filter
      sortBy: null,
      sortDesc: null,
      //Tinh trang cua Du an hop dong
      tinhtrang: -1,
      // reportModalShow: false,
      // contractModalShow: false,
      optionsTinhTrang: [
        { value: 1, text: "Not acceptance" },
        { value: 2, text: "Unpaid" },
        { value: 3, text: "Done" },
      ],
      year_selected: 0,
      month_selected: 0,
      optionsMonth: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
        { value: 13, text: "Q1" },
        { value: 14, text: "Q2" },
        { value: 15, text: "Q3" },
        { value: 16, text: "Q4" },
      ],

      // optionsMonth: [
      //   { value: 1, text: "Tháng 1" },
      //   { value: 2, text: "Tháng 2" },
      //   { value: 3, text: "Tháng 3" },
      //   { value: 4, text: "Tháng 4" },
      //   { value: 5, text: "Tháng 5" },
      //   { value: 6, text: "Tháng 6" },
      //   { value: 7, text: "Tháng 7" },
      //   { value: 8, text: "Tháng 8" },
      //   { value: 9, text: "Tháng 9" },
      //   { value: 10, text: "Tháng 10" },
      //   { value: 11, text: "Tháng 11" },
      //   { value: 12, text: "Tháng 12" },
      //   { value: 13, text: "Quý I" },
      //   { value: 14, text: "Quý II" },
      //   { value: 15, text: "Quý III" },
      //   { value: 16, text: "Quý IV" },
      // ],
    };
  },
  computed: {
    project_contract_read() {
      return this.$store.getters.hasPermission("project_contract_read");
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = this_year; i >= 2020; i--) {
        result.push({ value: i, text: i });
      }
      return result;
    },
    sum_giatriduocnghiemthu() {
      var sum = 0;
      for (var item of this.items) {
        sum += item.giatriduocnghiemthu;
      }
      return sum;
    },
    sum_dathanhtoan() {
      var sum = 0;
      for (var item of this.items) {
        sum += item.dathu;
      }
      return sum;
    },
    sum_conphaithanhtoan() {
      return this.sum_giatriduocnghiemthu - this.sum_dathanhtoan;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/customercontract", { params: to.query }),
        axios.get("/"),
        axios.get("/api/picklist?q=tinhtranghopdong"),
        axios.get("/api/customercontractpay/nextpaymentdate"),
      ])
      .then(
        axios.spread(
          (customercontract, department, tinhtranghopdong, paymentdate) => {
            next((vm) =>
              vm.initData(
                customercontract.data,
                department.data,
                tinhtranghopdong.data,
                paymentdate.data
              )
            );
          }
        )
      );
  },

  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/customercontract", { params: to.query })
      .then((response) => {
        this.items = response.data;
        this.totalRow = this.items.length;
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(customercontracts, departments, tinhtranghopdongs, paymentdates) {
      this.items = customercontracts;
      this.departments = departments;
      this.tinhtranghopdongs = tinhtranghopdongs;
      this.paymentdates = paymentdates;

      this.year_selected = new Date().getFullYear();
      this.month_selected = 0;
      this.tinhtrang = -1;
    },

    formatPrice(value) {
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    addItem() {
      this.$router.push(`/add_contract`);
    },
    updateItem(data) {
      this.$router.push(`/contract/${data.item.id}`);
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/customercontract/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    findNextPaymentDate(list, contractid) {
      const found = list.find((x) => x.customerContractId == contractid);

      if (typeof found == "undefined") return "";

      return found.ngaynhandukien;
    },
    findPickList(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      //return temp == null ? "" : temp.tendonvi;
      return temp == null ? "" : temp.madonvi;
    },
    //Filter
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.tinhtrang = this.tinhtrang; //tinhtrang cho contract
      this.item = null;
      this.$router.push({ query: query });
      // axios.get("/api/customercontract", {params: query})
      // .then((res) => {
      //   this.items = res.data;
      // });

      //Thay doi mau cua thanh filter trangthai
      // var optionElement = document.getElementById("rgb");
      // if (optionElement != null) {
      //   switch (this.tinhtrang) {
      //     case "-1":
      //       optionElement.style.background = "#FFEEFD";
      //       break;
      //     case "1":
      //       optionElement.style.background = "#FFE1C6";
      //       break;
      //     case "2":
      //       optionElement.style.background = "#FFFFD7";
      //       break;
      //     case "3":
      //       optionElement.style.background = "#C0F7FE";
      //       break;
      //   }
      // }
      // this.item = null;
      // this.$router.push({ query: query });
    },
    filterStatus() {
      let query = Object.assign({}, this.$route.query);
      query.tinhtrang = this.tinhtrang;
      // query.page = 1;
      // this.currentPage = 1;
      this.$router.push({ query: query });
    },
    sortChanged(ctx) {
      this.item = null;
      let query = Object.assign({}, this.$route.query);
      query.sortBy = ctx.sortBy;
      query.sortDesc = ctx.sortDesc;
      this.$router.push({ query: query });
    },
    // openReportModal() {
    //   this.reportModalShow = true;
    // },
    // closeReportModal() {
    //   this.reportModalShow = false;
    // },
    // selectContract() {
    //   this.contractModalShow = true;
    // },
    // closeContractModal() {
    //   this.contractModalShow = false;
    // },
  },
};
</script>
<style scoped>
option {
  background: #fff;
}
.badge {
  /* padding: 1px 9px 2px; */
  font-size: 13.025px;
  font-weight: bold;
  white-space: nowrap;
  background-color: #999999;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.badge-success {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-success:hover {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-primary {
  color: #383838;
  background-color: #ffffd7;
}
.badge-primary:hover {
  color: #383838;
  background-color: #ffffd7;
}

.badge-info {
  color: #383838;
  background-color: #ffe1c6;
}
.badge-info:hover {
  color: #383838;
  background-color: #ffe1c6;
}

.badge-warning {
  color: #ffffff;
  background-color: #fc8b28;
}
.badge-warning:hover {
  color: #ffffff;
  background-color: #fc8b28;
}

.badge-danger {
  color: #ffffff;
  background-color: #df515f;
}
.badge-danger:hover {
  color: #ffffff;
  background-color: #df515f;
}

.badge-danger2 {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger2:hover {
  color: #ffffff;
  background-color: #c55e97;
}
</style>
<style>
.tooltip .tooltip-inner {
  max-width: 500px !important;
  width: 300px !important;
  background: #fdfd96;
  text-align: left;
  color: black;
  white-space: pre-line;
  /* xuong hang cho tooltip */
}
</style>

<style scoped>
option {
  background: #fff;
}
.badge {
  /* padding: 1px 9px 2px; */
  font-size: 13.025px;
  font-weight: bold;
  white-space: nowrap;
  background-color: #999999;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.badge-success {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-success:hover {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-primary {
  color: #383838;
  background-color: #ffffd7;
}
.badge-primary:hover {
  color: #383838;
  background-color: #ffffd7;
}

.badge-info {
  color: #383838;
  background-color: #ffe1c6;
}
.badge-info:hover {
  color: #383838;
  background-color: #ffe1c6;
}

.badge-warning {
  color: #ffffff;
  background-color: #fc8b28;
}
.badge-warning:hover {
  color: #ffffff;
  background-color: #fc8b28;
}

.badge-danger {
  color: #ffffff;
  background-color: #df515f;
}
.badge-danger:hover {
  color: #ffffff;
  background-color: #df515f;
}

.badge-danger2 {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger2:hover {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger3 {
  color: #ffffff;
  background-color: #c55e5e;
  font-size: inherit;
  font-weight: 400;
}
.badge-danger3:hover {
  color: #ffffff;
  background-color: #c55e5e;
  font-size: inherit;
}
.badge-info3 {
  color: #ffffff;
  background-color: #44852d;
  font-size: inherit;
  font-weight: 400;
}
.badge-info3:hover {
  color: #383838;
  background-color: #e2ffd7;
  font-size: inherit;
}
</style>
